module.exports = __webpack_public_path__ + "static/media/Rubik-Medium.943a927c.woff2";